import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "isolate inline-flex h-[34px] min-w-0 items-center overflow-hidden rounded-lg border border-gray-300 bg-white shadow-sm" }
const _hoisted_2 = { class: "hidden min-w-0 items-center gap-1.5 pl-3 pr-2.5 text-[13px] text-gray-600 sm:flex" }
const _hoisted_3 = { class: "max-w-[360px] truncate" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = ["href"]

import { ArrowUpRightIcon, CheckIcon, ClipboardDocumentIcon } from '@heroicons/vue/20/solid'
import { GlobeAltIcon } from '@heroicons/vue/24/outline'
import { computed, onBeforeUnmount, ref } from 'vue'

const COPIED_FOR_MS = 2000


export default {
  __name: 'CopyableLink',
  props: {
  link: { type: String, default: '' }
},
  setup(__props) {

const props = __props

const copied = ref(false)
let timer = null

const displayLink = computed(() => props.link.replace(/^https?:\/\//, ''))

const copy = () => {
  navigator.clipboard.writeText(props.link)
  copied.value = true
  clearTimeout(timer)
  timer = setTimeout(() => {
    copied.value = false
  }, COPIED_FOR_MS)
}

onBeforeUnmount(() => clearTimeout(timer))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(_unref(GlobeAltIcon), {
        class: "h-3.5 w-3.5 shrink-0 text-gray-400",
        "aria-hidden": "true"
      }),
      _createElementVNode("span", _hoisted_3, _toDisplayString(displayLink.value), 1)
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "flex h-[34px] w-9 shrink-0 items-center justify-center text-gray-500 hover:bg-gray-100 sm:border-l sm:border-gray-200",
      "aria-label": copied.value ? 'Link copied' : 'Copy link',
      onClick: copy
    }, [
      (copied.value)
        ? (_openBlock(), _createBlock(_unref(CheckIcon), {
            key: 0,
            class: "h-4 w-4",
            "aria-hidden": "true"
          }))
        : (_openBlock(), _createBlock(_unref(ClipboardDocumentIcon), {
            key: 1,
            class: "h-4 w-4",
            "aria-hidden": "true"
          }))
    ], 8, _hoisted_4),
    _createElementVNode("a", {
      href: props.link,
      target: "_blank",
      rel: "noopener",
      class: "flex h-[34px] w-9 shrink-0 items-center justify-center border-l border-gray-200 text-gray-500 hover:bg-gray-100",
      "aria-label": "Open in a new tab"
    }, [
      _createVNode(_unref(ArrowUpRightIcon), {
        class: "h-4 w-4",
        "aria-hidden": "true"
      })
    ], 8, _hoisted_5)
  ]))
}
}

}